import {
	IAppWillMountHandler,
	WixBiSession,
	BusinessLogger,
	ReporterEvent,
	IReporterApi,
} from '@wix/thunderbolt-symbols'
import { IFeatureState } from 'thunderbolt-feature-state'

export type ReporterSiteConfig = {
	userId: string
	metaSiteId: string
	isPremium: boolean
	isViewerMode: boolean
	isFBServerEventsAppProvisioned: boolean
	dynamicPagesIds: Array<string>
}

export type ReporterMasterPageConfig = {
	appPages: {
		[pageIds: string]: {
			appDefId: string
			tpaPageId: string
		}
	}
}

export { ReporterEvent, IReporterApi }

export interface ReporterState {
	pageNumber: number
	pageUrl: URL
	pageId: string
	sendDeferredPageView: () => void
}

export type IReporterInit = (
	featureState: IFeatureState<ReporterState>,
	siteConfig: ReporterSiteConfig,
	wixBiSession: WixBiSession,
	businessLogger: BusinessLogger
) => IAppWillMountHandler

declare global {
	interface Window {
		promoteAnalyticsChannels?: Array<any>
		fbq?: Function
		ga?: Function
		dataLayer?: Array<any>
		ym?: { hit: Function }
	}
}

export enum PiiParams {
	buyerMail = 'buyerMail',
	buyerId = 'buyerId',
}

export enum ViewerType {
	TB = 'TB',
}

export enum PageType {
	Static = 'static',
	TPA = 'TPA',
	Dynamic = 'dynamic',
}

export enum PageApp {
	Editor = 'editor',
	Dynamic = 'dynamic',
}
